<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-04-28 16:25 -->
<!-- Description:  -->
<template>
  <div>
    <div class="text-secondary">
      ID: {{ client_id }}
    </div>
    <div>Tratamientos: {{treatments_count}}</div>
    <div>Citas: {{treatments_count}}</div>
    <div>Ventas: Tratamientos {{treatments_count}}</div>
    <div></div>
  </div>
</template>
<script>
import {StoreService} from "src/store-module/StoreService.js";
import DentalClinicService from "../service.js";

// script content
export default {
  name: "PatientProfileResume",
  components: {
    //
  },

  // directives

  props: {
    client_id: {}
  },

  data: () => ({
    treatments_count: 0,
    quotes_count: 0,
    sales_count: 0,
  }),

  computed: {
    //
  },

  // watch: {},

  async mounted() {
    let [
    treatments,
    quotes,
    sales,
    ] = await Promise.all([
      DentalClinicService.getTreatmentPlans({client_id: this.client_id}),
      DentalClinicService.getQuotes({client_id: this.client_id}),
      StoreService.getSales({client_id: this.client_id}),
    ]);
    this.treatments_count = treatments.total;
    this.quotes_count = quotes.total;
    this.sales_count= sales.total;
  },

  methods: {
    //
    //
    //
  }
};
</script>
<style scoped></style>

